//Export API url
export const API_URL = 'https://sanlyfeapi.danimtech.com/';
//export const API_URL = 'http://localhost:5000/';